var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.11433,0,0,1.11433,-1.22485,1.11149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.396,18.525L8.357,18.563L8.356,18.566L8.396,18.525Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.02107,0,0,2.35422,-4.42086,-6.35261)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(9.84589,0,0,9.84589,2.741,11.4224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.276,0.013C0.224,0.013 0.179,0.008 0.142,-0.003C0.105,-0.014 0.07,-0.028 0.038,-0.043L0.038,-0.165L0.044,-0.165C0.076,-0.135 0.112,-0.111 0.153,-0.095C0.193,-0.079 0.232,-0.07 0.27,-0.07C0.323,-0.07 0.363,-0.081 0.391,-0.104C0.418,-0.126 0.432,-0.155 0.432,-0.192C0.432,-0.221 0.424,-0.244 0.41,-0.263C0.396,-0.281 0.373,-0.294 0.342,-0.303C0.319,-0.31 0.299,-0.315 0.28,-0.319C0.262,-0.324 0.238,-0.329 0.21,-0.336C0.185,-0.343 0.163,-0.351 0.143,-0.361C0.123,-0.371 0.106,-0.385 0.09,-0.401C0.075,-0.417 0.064,-0.436 0.055,-0.457C0.047,-0.479 0.043,-0.504 0.043,-0.532C0.043,-0.591 0.066,-0.641 0.112,-0.68C0.158,-0.72 0.216,-0.74 0.288,-0.74C0.328,-0.74 0.367,-0.736 0.403,-0.728C0.439,-0.72 0.473,-0.708 0.504,-0.693L0.504,-0.578L0.497,-0.578C0.473,-0.599 0.444,-0.617 0.408,-0.633C0.372,-0.649 0.334,-0.657 0.294,-0.657C0.249,-0.657 0.213,-0.646 0.185,-0.625C0.157,-0.604 0.144,-0.577 0.144,-0.542C0.144,-0.512 0.152,-0.487 0.168,-0.469C0.184,-0.451 0.208,-0.437 0.239,-0.429C0.259,-0.423 0.284,-0.417 0.314,-0.41C0.344,-0.403 0.368,-0.396 0.388,-0.391C0.438,-0.375 0.474,-0.352 0.498,-0.321C0.521,-0.29 0.532,-0.252 0.532,-0.207C0.532,-0.179 0.526,-0.151 0.515,-0.123C0.503,-0.095 0.487,-0.072 0.466,-0.053C0.443,-0.032 0.416,-0.015 0.387,-0.004C0.358,0.007 0.321,0.013 0.276,0.013Z",
    style: {
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(9.84589,0,0,9.84589,8.22642,11.4224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.495,-0L0.074,-0L0.074,-0.727L0.17,-0.727L0.17,-0.086L0.495,-0.086L0.495,-0Z",
    style: {
      fillRule: "nonzero"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlr);
export default __webpack_public_path__ + "static/media/slr.c1a3938e.svg";
export { ForwardRef as ReactComponent };